<script setup lang="ts">
import { datePickerProps } from 'naive-ui';

const props = defineProps({
  ...datePickerProps,
  /** Dates in this app are points in time (due dates, effective dates). */
  type: {
    type: String as () => 'date' | 'datetime' | 'daterange' | 'datetimerange' | 'month' | 'year',
    default: 'date',
  },
  /** A date is almost always optional — clearing must be possible. */
  clearable: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <!-- Themed n-date-picker (shares the Input theme section) — a review's due
       date, a date-typed extracted value. Pass `type="datetime"` where the
       time of day carries meaning. -->
  <n-date-picker v-bind="props" />
</template>
